/* eslint-disable*/
import VueStoreService from './VueStoreService';
const UserService = {
    async getUsers(url,store){
        var resp = await VueStoreService.get("user"+url, store)
        return resp;
    },  
    async saveUser(data,store){
        var resp = await VueStoreService.post("user",data,store)
        return resp;
    },
    async getUser(user_id,store){
        var resp = await VueStoreService.get("user/"+user_id,store)
        return resp;
    },
    async updateUser(user_id,data,store){
        var resp = await VueStoreService.patch("user/"+user_id,data,store)
        return resp;
    },
    async changePassword(user_id,data,store){
        var resp = await VueStoreService.patch("api/auth/changePassword/"+user_id,data,store)
        return resp;
    },

    async deleteUser(user_id,store){
        var resp = await VueStoreService.delete("user/"+user_id,store)
        return resp;
    },
}

export default UserService;